export default __webpack_public_path__ + "static/char-s-17-jp-908b5fae2e9945e5f63e368c67b7c01e.webp";